module.exports = __webpack_public_path__ + "img/layout_thumb_top.02f0c8a8.png";